import React, {Component} from 'react';

import {UserModuleManageAccountsContent} from "./UserModuleManageAccountsContent";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class UserModuleManageAccountsClass extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulUserUpdated = this.afterSuccessfulUserUpdated.bind(this);
    }

    afterSuccessfulUserUpdated() {
        const { t } = this.props;
        alert(t('user.user_updated_successfully'))
    }

    render() {
        return (
            <UserModuleManageAccountsContent
                userId={this.props.match.params.id}
                afterSuccessfulUserUpdated={this.afterSuccessfulUserUpdated}
            />
        )
    }
}

const UserModuleManageAccounts = withRouterParams(withTranslation()(UserModuleManageAccountsClass));
export default UserModuleManageAccounts;
